<template>
  <OnClickOutside @trigger="isOpen = false">
    <div
      id="trigger"
      class="w-full h-full flex items-center justify-center cursor-pointer"
      @click="isOpen = !isOpen"
    >
      <slot name="trigger" />
    </div>
    <div v-show="isOpen">
      <slot name="menu" />
    </div>
  </OnClickOutside>
</template>

<script lang="ts" setup>
import { OnClickOutside } from '@vueuse/components'
import { ref } from 'vue'

const isOpen = ref<boolean>(false)
</script>
